import { render } from "./SimulationModal.vue?vue&type=template&id=7f378387&scoped=true&ts=true"
import script from "./SimulationModal.vue?vue&type=script&lang=ts"
export * from "./SimulationModal.vue?vue&type=script&lang=ts"

import "./SimulationModal.vue?vue&type=style&index=0&id=7f378387&scoped=true&lang=css"

import exportComponent from "/Users/garyfang/Documents/Projects/vue/boxing_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f378387"]])

export default __exports__